/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import EditableText from 'material/embeds/editabletext/editabletext_container';
import Delete from 'material/embeds/embed/edit/delete/delete_container';
import Correct from 'material/embeds/embed/edit/correct/correct_container';
import ImageIndicator from 'material/embeds/imageindicator/imageindicator';
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/shared/answer/image1/image1_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER IMAGE 1 : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AnswerImage1 extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: false, isImageValid: null, isTextValid: null };
        this.characterLimit = 15;
        this.handleImageSelect = this.handleImageSelect.bind(this);
        this.handleTextSelect = this.handleTextSelect.bind(this);
        this.getInlineStyles = this.getInlineStyles.bind(this);
        this.validateOption = this.validateOption.bind(this);
    }
    componentWillMount() {
        if (this.props.isEditable) {
            this.validateOption(this.props.text, this.props.imageURL, true);
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.isEditable && (this.props.text !== prevProps.text || this.props.imageURL !== prevProps.imageURL)) {
            this.validateOption(this.props.text, this.props.imageURL, false);
        } else if (this.props.isValid === false && (this.props.isValid !== prevProps.isValid)) {
            this.validateOption(this.props.text, this.props.imageURL, false);
        }
    }
    validateOption(text = this.props.text, image = this.props.imageURL, isInitialValidation = false) {
        const isTextValid = this.validateText(text, isInitialValidation);
        const isImageValid = this.validateImage(image, isInitialValidation);
        const isValid = (isTextValid === null && isImageValid === null) ? null : isTextValid && isImageValid ? true : { isImageValid, isTextValid };
        this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'isValid', isValid);
    }
    validateImage = (imageURL, isInitialValidation) => (
        isInitialValidation ? imageURL === null ? imageURL : true : imageURL !== null
    );
    validateText(text, isInitialValidation) {
        if (text !== null && text.length > this.characterLimit) { return null; }
        if (text === null) {
            return isInitialValidation ? this.props.text === null ? this.props.text : true : false;
        } else if (text.length > 0) {
            return true;
        } else if (text.length === 0) {
            return false;
        }
    }
    handleImageSelect() {
        this.props.setActiveSelection(this.props.isSelected ? 'none' : `option_${this.props.optionId}`);
    }
    handleTextSelect(text) {
        this.setState({ selected: !this.state.selected });
    }
    getInlineStyles() {
        const imgURL = this.props.imageURL === null ? `url(${url.image.app}/embed-default-image-${this.props.optionId}.jpg` : `url(${this.props.imageURL})`;
        const imgSrc = this.props.previewImageURL === null ? imgURL : `url(${this.props.previewImageURL})`;
        return { backgroundImage: imgSrc };
    }
    render() {
        const isImageValid = this.props.isValid instanceof Object ? this.props.isValid.isImageValid : this.props.isValid;
        const isTextValid = this.props.isValid instanceof Object ? this.props.isValid.isTextValid : this.props.isValid;
        const placeholderText = `Answer here`;
        return (
            <div className={`image1 ${this.props.classes.image1}`}>
                <span className={`photo`}>
                    <span className={`graphic selected-${this.props.isEditable && this.props.isSelected} valid-${!this.props.isEditable || !!isImageValid} editable-${this.props.isEditable}`} style={this.getInlineStyles()} onClick={this.handleImageSelect}>
                        <span className={`overlay`} />
                        <ImageIndicator color={`white`} />
                    </span>
                    <span className={`background selected-${this.state.selected} valid-${!this.props.isEditable || !!isTextValid}`}><span className={`overlay`} /></span>
                    <span className={`desc`}>
                        <span className={`text`}>
                            <EditableText contentId={this.props.contentId}
                                          isOption={true}
                                          optionId={this.props.optionId}
                                          placeholderText={placeholderText}
                                          isEditable={this.props.isEditable}
                                          onFocus={this.handleTextSelect}
                                          onBlur={this.handleTextSelect}
                                          characterLimit={this.characterLimit}
                                          preventEnter={true}
                            />
                        </span>
                    </span>
                    <Delete contentId={this.props.contentId} optionId={this.props.optionId} position={`top right`} />
                    <Correct contentId={this.props.contentId} optionId={this.props.optionId} type={`image1`} />
                </span>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(AnswerImage1);
